import { AxiosResponse } from 'axios';

import { FetchCompaniesRequestType } from './types';

import { CommonResponseType } from 'api/authApi';
import { GeneralResponseType } from 'common';
import { authServiceClient } from 'config';
import { CompanyType } from 'state/reducers/companies/types';

export const fetchCompaniesRequest = (params: FetchCompaniesRequestType) => {
  return authServiceClient.get<
    GeneralResponseType<CompanyType>,
    AxiosResponse<GeneralResponseType<CompanyType>>,
    FetchCompaniesRequestType
  >(`/company`, { params });
};

export const fetchCertainCompanyRequest = (id: string) => {
  return authServiceClient.get<CompanyType, AxiosResponse<CompanyType>>(`/company/${id}`);
};

export const createCompanyRequest = (name: string) => {
  return authServiceClient.post<
    CompanyType,
    AxiosResponse<CompanyType>,
    { name: string }
  >(`/company`, { name });
};

export const editCompanyRequest = (name: string, id: string) => {
  return authServiceClient.put<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    { name: string }
  >(`/company/${id}`, { name });
};

export const addUserToCompanyRequest = (companyId: string, userId: string) => {
  return authServiceClient.post<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    { userId: string }
  >(`/company/${companyId}/add-user`, { userId });
};

export const removeUserFromCompanyRequest = (companyId: string, userId: string) => {
  return authServiceClient.post<
    CommonResponseType,
    AxiosResponse<CommonResponseType>,
    { userId: string }
  >(`/company/${companyId}/remove-user`, { userId });
};
